import { getUserInfo, hasToken } from '@/utils/token'
import type { Settings as LayoutSettings } from '@ant-design/pro-components'
import '@ant-design/v5-patch-for-react-19'
import type { RequestConfig, RunTimeLayoutConfig } from '@umijs/max'
import { history, Link } from '@umijs/max'
import defaultSettings from '../config/defaultSettings'
import { errorConfig } from './requestErrorConfig'

const loginPath = '/user/login'
const mainMenuPaths = [
  '/console-home',
  '/order-management',
  '/inventory-management',
  '/stock-in-management',
  '/stock-out-management',
]
const mainMenuDividerPath = '/__menu-divider__/main-menu'
const menuSectionDividerPath = '/__menu-divider__/basic-settings'
type CurrentUser = {
  name?: string;
  avatar?: string;
  access?: string;
}

export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: CurrentUser;
}> {
  if (hasToken()) {
    const userInfo = getUserInfo()

    return {
      currentUser: {
        name: userInfo?.realName || userInfo?.username || '系统用户',
        avatar: userInfo?.avatar,
        access: 'admin',
      },
      settings: defaultSettings as Partial<LayoutSettings>,
    }
  }

  if (history.location.pathname !== loginPath) {
    history.push(loginPath)
  }

  return {
    settings: defaultSettings as Partial<LayoutSettings>,
  }
}

export const layout: RunTimeLayoutConfig = ({ initialState }) => {
  return {
    waterMarkProps: {},
    onPageChange: () => {
      const { location } = history
      const isLoggedIn = hasToken()

      if (!isLoggedIn && location.pathname !== loginPath) {
        history.push(loginPath)
        return
      }

      if (isLoggedIn && location.pathname === loginPath) {
        history.push('/console-home')
      }
    },
    menuHeaderRender: undefined,
    menuDataRender: (menuData) => {
      const mainMenus = menuData.filter((item) =>
        mainMenuPaths.includes(item.path || ''),
      )
      const settingMenus = menuData.filter(
        (item) =>
          item.path &&
          !mainMenuPaths.includes(item.path) &&
          item.path !== '/basic-settings',
      )

      return [
        {
          path: mainMenuDividerPath,
          name: '主菜单',
        },
        ...mainMenus,
        {
          path: menuSectionDividerPath,
          name: '基础设置',
        },
        ...settingMenus,
      ]
    },
    menuItemRender: (item, defaultDom) => {
      if (
        item.path === mainMenuDividerPath ||
        item.path === menuSectionDividerPath
      ) {
        return <div className="menu-section-divider">{item.name}</div>
      }

      if (item.isUrl) {
        return (
          <a href={item.path} target="_blank" rel="noreferrer">
            {defaultDom}
          </a>
        )
      }

      if (item.path) {
        return <Link to={item.path}>{defaultDom}</Link>
      }

      return defaultDom
    },
    ...initialState?.settings,
  }
}
export const request: RequestConfig = {
  baseURL: '/',
  ...errorConfig,
}
